import * as style from "@COMPONENTS/style/detailpackage/promotionlinkM";
import {Area} from "@FRAMEWORK/ui/mobile/layout";
import {memo} from "react";
import useEventPromotion from "@QUERIES/prdt/event/useEventPromotion";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import {TDetailPackage} from "@COMPONENTS/product/types";
import {useTaggingClick} from "@/hooks/common/useTagging";
import {onClickSSO} from "@COMPONENTS/common/commonUtil";

const DetailPromotionComponent = (props: TDetailPackage) => {
	const {query} = props;
	const useEvtPromotion = useEventPromotion(query.evCd);
	const promotionList = useEvtPromotion.data?.body || [];

	const {taggingClick} = useTaggingClick("pkg_select_promo_dtl", {selectDiv: "relatedBanner"});
	return (
		<>
			{promotionList.length > 0 && (
				<Area>
					<style.Wrap>
						<style.SubTitle>관련 기획전</style.SubTitle>
						<style.LinkList>
							{promotionList.map(({mstLink, mstNm}, index) => (
								<style.LinkListItem key={index}>
									<style.Link
										href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}${mstLink}`}
										onClick={e => {
											e.preventDefault();
											taggingClick({link: mstLink, title: mstNm});
											onClickSSO(e, `${publicRuntimeConfig.ENV_PACKAGE_M_URL}${mstLink}`);
										}}
									>
										<style.LinkTitle dangerouslySetInnerHTML={{__html: mstNm.replaceAll(/<br\s*\/?>/gi, "")}} />
										<style.LinkArrow />
									</style.Link>
								</style.LinkListItem>
							))}
						</style.LinkList>
					</style.Wrap>
				</Area>
			)}
		</>
	);
};

const DetailPromotion = (props: TDetailPackage) => (
	<ErrorBoundary logMsg="EventDetailPromotion Error">
		<DetailPromotionComponent {...props} />
	</ErrorBoundary>
);

export default memo(DetailPromotion);
